import { deserializeData } from '../store';
import type { SerializeData } from '../store';
import type { StorageProvider } from './provider';

const downloadAnchorNode = document.createElement('a');
document.body.appendChild(downloadAnchorNode); // required for firefox
downloadAnchorNode.style.display = 'none';

const input = document.createElement('input');
input.type = 'file';
document.body.appendChild(input);
input.style.display = 'none';

/**
 * Uses the File API to save and load data
 */
export const fileApiProvider: StorageProvider = {
  saveData(data: SerializeData) {
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    downloadAnchorNode.href = URL.createObjectURL(blob);
    downloadAnchorNode.download = `Issue Form.json`;
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  },

  saveAs(data: SerializeData) {
    this.saveData(data);
  },

  async loadData(): Promise<SerializeData | null> {
    input.click();
    const file = await new Promise<File | null>(resolve => {
      input.onchange = () => resolve(input.files?.[0] ?? null);
    });
    if (!file) {
      return null;
    }

    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = () => {
        try {
          resolve(deserializeData(JSON.parse(reader.result as string)));
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = reject;
      reader.readAsText(file);
    });
  },
};
